// @ts-strict-ignore
import type { SchemaInstance, WorkflowProps } from 'flow/store/engine/types';
import type { WorkflowState } from '../state';
import type { Snapshot, WorkflowSnapshots } from '../types';
import { createSnapshot, trimSubsequentSnapshots } from 'flow/service/history';

export function clearWorkflowSnapshots(
  state: WorkflowState,
) {
  const currentWorkflowData = state.workflowData;
  const currentWorkflowProps = state.workflowProps;
  state.workflowSnapshots.workflowData.history.initial = createSnapshot({
    data: currentWorkflowData,
  });
  state.workflowSnapshots.workflowData.history.past = [];
  state.workflowSnapshots.workflowProps.history.initial = createSnapshot({
    data: currentWorkflowProps,
  });
}

export function updateWorkflowSnapshots(
  state: WorkflowState,
  action: {
    payload: {
      workflowSnapshots: WorkflowSnapshots;
    };
  },
) {
  const { workflowSnapshots } = action.payload;
  state.workflowSnapshots = workflowSnapshots;
}

export function applyWorkflowDataSnapshot(
  state: WorkflowState,
  action: {
    payload: {
      snapshot: Snapshot<Partial<SchemaInstance>>;
    };
  },
) {
  state.workflowData = action.payload.snapshot.data;
}

export function applyWorkflowPropsSnapshot(
  state: WorkflowState,
  action: {
    payload: {
      snapshot: Snapshot<WorkflowProps>;
    };
  },
) {
  state.workflowProps = action.payload.snapshot.data;
}

/** Removes the snapshots from the array that come after the snapshot identified by snapshotId. */
export function removeSubsequentWorkflowDataSnapshots(
  state: WorkflowState,
  action: {
    payload: {
      snapshotId: Snapshot<Partial<SchemaInstance>>['snapshotId'];
    };
  },
) {
  const { snapshotId } = action.payload;
  if (state.workflowSnapshots.workflowData.history.initial.snapshotId === snapshotId) {
    state.workflowSnapshots.workflowData.history.past = [];
    return;
  }

  const snapshots = state.workflowSnapshots.workflowData.history.past;
  state.workflowSnapshots.workflowData.history.past = (
    trimSubsequentSnapshots(snapshots, snapshotId)
  );
}
